import translationService from "../app/TranslationService";
import internalStateService from "../app/InternalStateService";
import ArrayUtils from "@tinqin/tinqin-utils/src/array";

export const DISMISS_MESSAGES = "DISMISS_MESSAGES";
export const TRIGGER_MESSAGES = "TRIGGER_MESSAGES";

export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
export const ADD_NOTIFICATIONS = "ADD_NOTIFICATIONS";

function closeMessages() {
    return {
        type: DISMISS_MESSAGES,
        opened: false
    };
}

export function dismissMessages() {
    return (dispatch, getState) => {
        return dispatch(closeMessages());
    };
}

export function triggerMessages(messages, options = {}) {
    return {
        type: TRIGGER_MESSAGES,
        payload: {
            content: messages,
            ...options
        }
    };
}

//opening confirm/info message
export function confirmMessageFromSirenAction(sirenAction = {}, widgetId, entityPath) {
    let defaultConfig = internalStateService.getActionsDefaultConfig()["confirm"] || {};
    // properties:{
    //         type:"", title:"", message:"",
    //         actions:[
    //         {
    //             id:confirm, label: "", icon: "", style: ""
    //         },
    //         {
    //             id:cancel, label: "", icon: "", style: ""
    //         },
    //         {
    //             id:close, label: "", icon: "", style: ""
    //         }
    // ]
    // }
    let properties = sirenAction.properties || {};
    let {
        type = properties.type || "info",
        title,
        message,
        actions = properties.action || []
    } = properties;

    let confirmPresentation = [];
    confirmPresentation = actions.filter(action => {
        return action.id === "confirm";
    });
    let cancelPresentation = [];
    cancelPresentation = actions.filter(action => {
        return action.id === "cancel";
    });
    let closePresentation = [];
    closePresentation = actions.filter(action => {
        return action.id === "close";
    });

    let finallyActions = sirenAction.actions || [];

    let successAction = finallyActions.filter(action => {
        let events = action.events || ["default"];
        return ArrayUtils.includesAtLeastOneOf(events, ["confirm", "default"]);
    });
    let cancelAction = finallyActions.filter(action => {
        let events = action.events || [];
        return events.includes("cancel");
    });
    let closeAction = finallyActions.filter(action => {
        let events = action.events || [];
        return events.includes("close");
    });

    return dispatch => {
        const dispatchSirenActions = internalStateService.getActionByName(
            "siren.dispatchSirenActions"
        );

        let messageProperties = {
            type,
            title,
            message
        };
        let options = {};
        //we can have actions and presentation coming from project configuration
        options["confirmButton"] = {
            action: () => {
                return dispatch(
                    dispatchSirenActions(successAction, widgetId, entityPath, [
                        "default",
                        "confirm"
                    ])
                );
            }
        };
        if (confirmPresentation.length) {
            options["confirmButton"]["presentation"] = confirmPresentation[0];
        }
        options["cancelButton"] = {
            action: () => {
                return dispatch(
                    dispatchSirenActions(cancelAction, widgetId, entityPath, ["cancel"])
                );
            }
        };
        if (cancelPresentation.length) {
            options["cancelButton"]["presentation"] = cancelPresentation[0];
        }

        options["closeButton"] = {
            action: () => {
                return dispatch(dispatchSirenActions(closeAction, widgetId, entityPath, ["close"]));
            }
        };

        if (closePresentation.length) {
            options["closeButton"]["presentation"] = closePresentation[0];
        }

        if (defaultConfig.hasOwnProperty("closable")) {
            options.closable = defaultConfig.closable;
        }
        return new Promise(() => {
            dispatch(
                triggerMessages(
                    [
                        {
                            type: messageProperties.type,
                            messages: messageProperties.message,
                            title: messageProperties.title
                        }
                    ],
                    options
                )
            );
        });
    };

    //return triggerConfirmMessage(messageProperties, options);
}

export function triggerNotificationMessage(messageProperties = {}) {
    let manageActionButtons = (resolve, reject) => {
        let result = {};
        if (messageProperties.type === "info") {
            let actions = messageProperties.actions || [];
            let confirmPresentation = actions.filter(action => {
                return action.id === "confirm";
            });
            let cancelPresentation = actions.filter(action => {
                return action.id === "cancel";
            });
            let closePresentation = actions.filter(action => {
                return action.id === "close";
            });

            if (cancelPresentation.length) {
                result["cancelButton"] = {
                    presentation: cancelPresentation[0],
                    action: () => {
                        return reject("User cancel action.");
                    }
                };
            }
            if (confirmPresentation.length) {
                result["confirmButton"] = {
                    presentation: confirmPresentation[0],
                    action: () => {
                        return resolve("User accepted action.");
                    }
                };
            }

            if (closePresentation.length) {
                result["closeButton"] = {
                    presentation: closePresentation[0],
                    action: () => {
                        return reject("User cancel action.");
                    }
                };
            }
        }

        return result;
    };

    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(
                triggerMessages(
                    [
                        {
                            type: messageProperties.type,
                            messages: messageProperties.message,
                            name: messageProperties.title
                        }
                    ],
                    manageActionButtons(resolve, reject)
                )
            );
        });
    };
}

export function triggerErrorMessage(messageProperties = {}, options = {}) {
    let confirmButtonLabel =
        translationService.translate("errorMessageConfirm") || translationService.translate("yes");
    let defaultConfig = internalStateService.getActionsDefaultConfig()["confirm"] || {};
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(
                triggerMessages(
                    [
                        {
                            type: "error",
                            messages: messageProperties.message,
                            name: messageProperties.title
                        }
                    ],
                    {
                        confirmButton: {
                            presentation: {
                                label: confirmButtonLabel
                            },
                            action: () => {
                                return resolve("User accepted action.");
                            }
                        },
                        closable: defaultConfig.closable
                    }
                )
            );
        });
    };
}
export function triggerConfirmMessage(messageProperties = {}, options = {}) {
    let defaultConfig = internalStateService.getActionsDefaultConfig()["confirm"] || {};
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(
                triggerMessages(
                    [
                        {
                            type: messageProperties.type,
                            messages: messageProperties.message,
                            name: messageProperties.title
                        }
                    ],
                    {
                        confirmButton: {
                            presentation: {
                                label: translationService.translate("yes")
                            },
                            action: () => {
                                return resolve("User accepted action.");
                            }
                        },
                        cancelButton: {
                            presentation: {
                                label: translationService.translate("no")
                            },
                            action: () => {
                                return reject("User cancel action.");
                            }
                        },
                        closable: defaultConfig.closable
                    }
                )
            );
        });
    };
}
export function openConfirmMessageFromSirenAction(action = {}) {
    let actionFields = action.fields || [];
    let messageType, title, message;
    let type = "info";
    actionFields.forEach(actionField => {
        //the type of modal to be displayed, info or confirm (having "OK" button only or "OK" and "Cancel")
        if (actionField.name === "messageType") {
            messageType = actionField.value;
        }
        //Modal Title
        if (actionField.name === "messageTitle") {
            title = actionField.value;
        }
        //message content
        if (actionField.name === "message") {
            message = actionField.value;
        }
        //message type, one of  [error, success, info, warnring, neutral]
        if (actionField.name === "type") {
            type = actionField.value;
        }
    });
    if (messageType === "info") {
        return openInfoMessage({
            title,
            type,
            messages: [message]
        });
    }
    return openConfirmMessage({
        title,
        type,
        messages: [message]
    });
}

export function openConfirmMessage(options = {}) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(
                triggerMessages(
                    [
                        {
                            type: options.type ? options.type : "info",
                            messages: options.messages,
                            name: options.title
                        }
                    ],
                    {
                        closeLabel: translationService.translate("no"),
                        acceptLabel: translationService.translate("yes"),
                        acceptActions: [
                            {
                                cb: () => {
                                    resolve("User accepted action.");
                                }
                            }
                        ],
                        closeActions: [
                            {
                                cb: () => {
                                    reject("User canceled action.");
                                }
                            }
                        ]
                    }
                )
            );
        });
    };
}

export function openInfoMessage(options = {}) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(
                triggerMessages(
                    [
                        {
                            type: options.type ? options.type : "info",
                            messages: options.messages,
                            name: options.title
                        }
                    ],
                    {
                        closeActions: [
                            {
                                cb: () => {
                                    resolve("User accepted action.");
                                }
                            }
                        ]
                    }
                )
            );
        });
    };
}

export function addNotification(action = {}) {
    let actionFields = action.fields || [];
    let type = "info";
    let title, message;
    actionFields.forEach(actionField => {
        if (actionField.name === "type") {
            type = actionField.value;
        }
        if (actionField.name === "messageTitle") {
            title = actionField.value;
        }
        if (actionField.name === "message") {
            message = actionField.value;
        }
    });
    return {
        type: ADD_NOTIFICATIONS,
        payload: {
            content: [
                {
                    type: type,
                    messages: [message],
                    name: title
                }
            ]
        }
    };
}

export function removeNotification(id) {
    return {
        type: REMOVE_NOTIFICATION,
        payload: {
            id: id
        }
    };
}
